<template>
  <navbar class="navbar-block">
    <sidebar-toggler v-if="isAuthenticated" class="d-block d-lg-none" mobile/>
    <navbar-logo :windowWidth="windowWidth" class="navbar-brand-full" href="/main" />
    <sidebar-toggler v-if="isAuthenticated" class="d-none d-lg-block" display="lg"/>
    <b-navbar-nav
      v-if="!isAuthenticated && $router.app._route.fullPath.includes('/main')"
      class="d-none d-lg-flex"
    >
      <b-nav-item class="px-2" href="#anchor-for-news">Новости</b-nav-item>
      <b-nav-item class="px-2" href="#anchor-for-events">Мероприятия
      </b-nav-item>
      <b-nav-item class="px-2" href="#anchor-for-tasks">О проекте
      </b-nav-item>
      <b-nav-item class="px-2" href="#anchor-for-images">Галерея
      </b-nav-item>
    </b-navbar-nav>
    <b-navbar-nav class="ml-auto nav-actions">
      <template v-if="isAuthenticated">
        <b-nav-item
          v-if="hasRole(roles_.student) || hasRole(roles_.content)"
          @click="onNotificationsClick"
        >
          <em class="far fa-lg fa-bell"></em>
          <b-badge v-show="unreadNots > 0" pill variant="danger">{{ unreadNots }}</b-badge>
          <div class="notsDiv">
            <notifications-modal />
          </div>
        </b-nav-item>
        <b-nav-item class="d-lg-flex" :href="appLink + '/doku.php?id=1start'" target="_blank">
          <em class="fas fa-lg fa-info-circle" aria-hidden="true" title="Справка"></em>
        </b-nav-item>
      </template>
      <b-nav-item
        class="d-lg-flex"
        v-b-modal.techSupportModal
      >
        <template v-if="windowWidth > 900">Тех. поддержка</template>
        <em v-else class="fas fa-lg fa-headset" aria-hidden="true" title="Тех. поддержка" />
      </b-nav-item>
      <b-nav-item class="mx-1" @click="exitAction()" v-if="isAuthenticated">Выход</b-nav-item>
      <b-nav-item class="mr-1" v-else>
        <router-link class="nav-link" to="login">Вход</router-link>
      </b-nav-item>
    </b-navbar-nav>
  </navbar>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { roles } from '@/config/roles'

import Navbar from '@/components/ui/navbar/Navbar.vue'
import SidebarToggler from '@/components/ui/sidebar/Toggler.vue'
import NavbarLogo from '@/components/ui/navbar/Logo.vue'

const NotificationsModal = () => import('@/components/common/modals/NotificationsModal.vue')

export default {
  name: 'NavbarContainer',
  components: {
    Navbar,
    SidebarToggler,
    NavbarLogo,
    NotificationsModal
  },
  data() {
    return {
      areNotificationsShown: false,
      windowWidth: 0,
      roles_: roles
    }
  },
  computed: {
    ...mapGetters({
      unreadNots: 'notifications/getUnreadNots',
      hasRole: 'currentUser/hasRole',
      appLink: 'dicts/getLink',
      isAuthenticated: 'currentUser/isAuthenticated'
    })
  },
  mounted() {
    this.windowWidth = window.innerWidth
    this.fetchLink()
    this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
      if (modalId === 'notificationsModal') {
        this.areNotificationsShown = false
      }
    })
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },
  methods: {
    exitAction() {
      this.signOut().then(() => {
        window.location = this.appLink
      })
    },
    onNotificationsClick() {
      if (!this.areNotificationsShown) {
        this.$bvModal.show('notificationsModal')
        this.areNotificationsShown = true
      } else {
        this.$bvModal.hide('notificationsModal')
        this.areNotificationsShown = false
      }
    },
    onResize() {
      this.windowWidth = window.innerWidth
    },
    ...mapActions({
      signOut: 'currentUser/signOut',
      fetchLink: 'dicts/fetchLink'
    })
  }
}
</script>

<style scoped>
@media screen and (max-width: 991.6px) {
  .navbar-block {
    position: relative !important;
  }
}
@media screen and (min-width: 575px) {
  .navbar-block {
    z-index: 200
  }
}
.nav-actions .nav-link {
  color: white !important;
  padding-left: 0 !important;
}
</style>
